import React from 'react';

import PropTypes from 'prop-types';

import { CommentHistory } from 'components/MyTaskArea/TaskDetailPage/CommentHistory/CommentHistory';
import { LastMessage } from 'components/MyTaskArea/TaskDetailPage/LastMessage/LastMessage';
import { TaskDetailType } from 'components/MyTaskArea/types';
import { SubTitle } from 'components/SubTitle/SubTitle';

import './TaskDetails.sass';

export const TaskDetails = ({
  taskData,
  formik,
  onDownloadAttachment,
  isSubmitting,
  submitError,
  entityNameMap,
  submitSuccess,
  comboBoxOptions,
}) => {
  const { name, lastMessage, messages } = taskData;

  return (
    <div className="task-details-container">
      {lastMessage && (
        <div className="task-details shadow-box">
          <SubTitle text={name} notFramed />
          <LastMessage
            lastMessage={lastMessage}
            formik={formik}
            isSubmitting={isSubmitting}
            submitError={submitError}
            submitSuccess={submitSuccess}
            entityNameMap={entityNameMap}
            comboBoxOptions={comboBoxOptions}
          />
        </div>
      )}
      <div className="shadow-box" id="task-comments">
        <CommentHistory messages={messages ?? []} onDownloadAttachment={onDownloadAttachment} />
      </div>
    </div>
  );
};

TaskDetails.propTypes = {
  taskData: TaskDetailType.isRequired,
  formik: PropTypes.object.isRequired,
  onDownloadAttachment: PropTypes.func,
  isSubmitting: PropTypes.bool,
  entityNameMap: PropTypes.object,
  submitError: PropTypes.string,
  submitSuccess: PropTypes.bool,
  comboBoxOptions: PropTypes.object,
};

TaskDetails.defaultProps = {
  onDownloadAttachment: () => {},
  isSubmitting: false,
  submitError: null,
  submitSuccess: false,
  entityNameMap: {},
  comboBoxOptions: {},
};
